module.exports = __webpack_public_path__ + "img/new.e3e51077.svg";